// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"211c60d37478fd051101","678":"4b6038d5eed7653c802d","883":"e34becbb866678bba065"}[chunkId] + ".js";
};